// extracted by mini-css-extract-plugin
export default {"tagsBar":"styles_tagsBar__AZvjh"};